import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import NProgress from 'nprogress'
import config from '../config'


NProgress.configure({ speed: 200, showSpinner:false });
// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

const AuthContainer = () => import('@/containers/AuthContainer')
// Views
const CurrentUserEdit = () => import ('@/views/account/Edit')


const Login = () => import('@/views/login/Login')

const BarDashboard = () => import('@/views/dashboard/BarDashboard')
const TransactionsReport = () => import('@/views/reports/bar/Transactions')
const TransactionReport = () => import('@/views/reports/bar/Transaction')
const ProductsReport = () => import('@/views/reports/bar/Products')
const CategoriesReport = () => import('@/views/reports/bar/Categories')
const UsersReport = () => import('@/views/reports/bar/Users')
const CashiersReport = () => import('@/views/reports/bar/Cashiers')
const BarOrdersList = () => import('@/views/reports/bar/BarOrdersList')
Vue.use(Router)

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/reports/bar/dashboard',
      name: 'Relatorios',
      component: DefaultContainer,
      meta: {
        requiresAuth: true,
        title: 'Relatórios',
        roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
      },
      children: [
        {
          path: '/reports/bar/dashboard',
          name: 'Bar / Dashboard',
          component: BarDashboard,         
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/bar/transactions',
          name: 'Bar / Transações',
          component: TransactionsReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },        
        {
          path: '/reports/bar/transaction/:id',
          props: true,
          name: 'Transação',
          component: TransactionReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/bar/products',
          name: 'Bar / Produtos',
          component: ProductsReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/bar/categories',
          name: 'Bar / Categorias',
          component: CategoriesReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/bar/users',
          name: 'Bar / Usuarios',
          component: UsersReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/bar/cashiers',
          name: 'Bar / Caixas',
          component: CashiersReport,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        },
        {
          path: '/reports/bar/orders',
          name: 'Bar / Pedidos',
          component: BarOrdersList,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Seller', 'Salesperson', 'Backoffice', 'Finance', 'Logistic']
          }
        }                        
      ]
    },
    {
      path: '/account',
      redirect: '/account/edit',
      name: 'Meu Cadastro',
      component: DefaultContainer,
      meta: {
        requiresAuth: true,
        title: 'Meu Cadastro',
        roles: ['Partner', 'Backoffice']
      },
      children: [
        {
          path: 'edit',
          name: 'Editar',
          component: CurrentUserEdit,
          meta: {
            requiresAuth: true,
            roles: ['Partner', 'Backoffice']
          }
        }
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Auth',
      component: AuthContainer,
      meta: {
        requiresAuth: false,
        title: 'Identificação'
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
          props: route => ({
            rt: route.query.rt
          })
        }
      ]
    }
  ]
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
      NProgress.start()
  }
  next()
})

router.afterEach(() => {
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    if (store.getters.isAuthenticated) {
      
      const matchedRole = to.meta.roles.find(function(role) {
        return store.getters.currentUser.role === role
      })

      if(matchedRole) {
        next()
      }
      else {
        next({
          path: '/reports/bar'
        })
      }
    } else {
      next({
        path: '/login'
      })
    }
  } else {
    next()
  }
})

export default router



